import Vue from "vue";
import {
  extend,
  ValidationProvider,
  localize
} from "vee-validate";
import {
  required,
  // email,
  confirmed
} from "vee-validate/dist/rules";
import emoji from 'emoji-regex';
import * as rules from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
localize("en", en);

// 邮箱
// extend("email", {
//   ...email,
//   message: "请输入正确的{_field_}"
// });
// 邮箱:全模块统一，修改知会全体前后端
extend('email', value => {
  //let re = /^([a-zA-Z0-9]+[_|\-|\.]?)+@([a-zA-Z0-9]+[_|\-|\.]?)+([a-zA-Z0-9]{1,})+\.[a-zA-Z]{2,}$/;
  // let re = /^[a-zA-Z0-9_-|\.|\-]+@[a-zA-Z0-9_-|\.|\-]+(\.[a-zA-Z]+)+$/;
  // let re = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  // let re = /^([a-zA-Z]|[0-9])(\w|\-|\.)+@(([a-zA-Z0-9]|\-|\.)*([a-zA-Z0-9]|\-))+\.[a-zA-Z]{2,}$/
  // if (!re.test(value)) {
  let re = /^([a-zA-Z]|[0-9])(\w|\-|\.)+@(([a-zA-Z0-9]|\-|\.)*([a-zA-Z0-9]|\-))$/
  const endStrArr = value.split(/\./),
        endDotStr = endStrArr.length>1?endStrArr.pop():'',
        endPerStr = endStrArr.pop();
  if ( !(re.test(value)&&endDotStr!==""&&endPerStr!==""&&/^[a-zA-Z]+$/.test(endDotStr)) ) {
    return '{_field_}格式不正确，请重新输入'
  } else if (value.length > 50) {
    return '{_field_}最多为50个字符，请重新输入'
  } else {
    return true
  }
})
// 统一的不能传入长度， 另起一个动态传入长度判断，防止内存泄漏
extend('maxEmail',{
  validate(value, args) {
    const maxCount = args.length||0
    let re = /^([a-zA-Z]|[0-9])(\w|\-|\.)+@(([a-zA-Z0-9]|\-|\.)*([a-zA-Z0-9]|\-))$/
    const endStrArr = value.split(/\./),
          endDotStr = endStrArr.length>1?endStrArr.pop():'',
          endPerStr = endStrArr.pop();
    if ( !(re.test(value)&&endDotStr!==""&&endPerStr!==""&&/^[a-zA-Z]+$/.test(endDotStr)) ) {
      return '{_field_}格式不正确，请重新输入'
    } else if (maxCount>0&&value.length > maxCount) {
      return `{_field_}最多为${args.length}个字符，请重新输入`
    } else {
      return true
    }
  },
  params: ['length'],
  message: '最多为 {length} 个字符，请重新输入'
})
// 两次输入密码不一致
extend("confirmed", {
  ...confirmed,
  message: "两次密码输入不一致，请重新输入"
});
//输入框不为空
extend("required", {
  ...required,
  message: "{_field_}不允许为空，请重新输入"
});

// 复选框必选
extend("requiredChoiced", {
  ...required,
  message: "请勾选用户协议"
});
//下拉框不为空
extend("selected", {
  ...required,
  message: "请选择{_field_}"
});
//复选框不为空
extend("checked", {
  ...required,
  message: "请勾选{_field_}"
});
// 自定义 阅读协议
extend("agreementChecked",{
  ...required,
  message: "请阅读并同意以上{_field_}"
})
//数字和字母
extend("alpha_num", {
  ...required,
  message: "请输入正确的{_field_}(由数字和字母组合)"
});

extend("requiredUpload", {
  ...required,
  message: "请{_field_}"
});
//最大
extend("max", {
  validate(value, args) {
    return value.length <= args.length;
  },
  params: ["length"],
  message: "长度不能超过 {length} 个字符"
});
// 字段最大字符，提示里面还有字段label，maxHasLabel:20
extend("maxHasLabel", {
  validate(value, args) {
    return value.length <= args.length;
  },
  params: ["length"],
  message: "{_field_}最多为{length}个字符，请重新输入"
});

// 区间范围 只能输入区间的字母或数字
extend("section", {
  validate(value, args) {
    let temp = args.section.split("-");
    if (value.length >= temp[0] && value.length <= temp[1]) {
      return /^[0-9a-zA-Z]*$/g.test(value);
    }
    return false;
  },
  params: ["section"],
  message: "{_field_}最多为{section}位数字或字母"
});

//3.自定义
extend("num", value => {
  let re = /^[0-9]+$/;
  if (re.test(value)) {
    return true;
  }
  return "只允许输入数字，请重新输入";
});

//3.银行卡号纯数字
extend("cardNum", value => {
  let re = /^[0-9]+$/;
  if (re.test(value)) {
    return true;
  }
  return "{_field_}格式不正确，请重新输入";
});
//大于1的正整数
extend("nums", value => {
  let re = /^\+?[1-9]\d*$/;
  if (re.test(value)) {
    return true;
  }
  return "请输入正确的{_field_}(大于0的数字,且保留两位小数)";
});
//手机bil号
extend("mobile", value => {
  let re = /^1[3456789]\d{9}$/;
  if (re.test(value)) {
    return true;
  }
  return "手机号码格式不正确，请重新输入";
});

//菜单编码,MENU+6位数字
extend("menuCode", value => {
  let re = /^MENU\d{6}$/;
  if (re.test(value)) {
    return true;
  }
  return "{_field_}格式不正确，请重新输入";
});

//菜单顺序，仅1-8位正整数
extend("menuOrder", value => {
  let re = /^[1-9]\d{0,7}$/;
  if (re.test(value)) {
    return true;
  }
  return "{_field_}格式不正确，请重新输入";
});

//连接地址:http://* | https://*
extend("httpUrl", value => {
  let re = /^((http|https):\/\/)?([\w.]+\/?)\S/;
  if (re.test(value)) {
    return true;
  }
  return "{_field_}格式不正确，请重新输入";
});
// 网址 带 http://  | https://
extend("httpUrl2", value => {
  let re = /^(http|https):\/\/([\w.]+\/?)\S/;
  if (re.test(value)) {
      return true;
  }
  return "{_field_}url不合法";
});

//邮编：10位以内纯数字
extend("zipCode", value => {
  let re = /^[0-9]{0,10}$/;
  if (re.test(value)) {
    return true;
  }
  return "{_field_}格式不正确，请重新输入";
});
//账号不支持中文 只能以字母开头 长度为8-32个字符 至少包含英文字母、数字或特殊字符(-_)中的两种
extend("eNameNum", value => {
  //let re = /(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{8,12}/;
  let regA = /^[a-zA-Z].*?$/;
  let regInclude = /^[_\-0-9a-zA-Z]{0,}$/;
  let regB = /^[A-Za-z]*[_\-A-Za-z0-9]*$/;
  if (!regA.test(value)) {
    return "{_field_}必须以字母开头";
  } else if (!regInclude.test(value)) {
    return "{_field_}只能包含字母、数字、-、_";
  } else if (value.length < 8 || value.length > 32) {
    return "{_field_}长度必须在8-32位";
  } else if (!regB.test(value)) {
    return "{_field_}只能包含字母、或者字母加数字、-、_的任意一种";
  } else {
    return true;
  }
});
// 开户支行特使处理下拉框不为空
extend("selectedBank", {
  ...required,
  message: "请选择或输入{_field_}"
});
extend("specialStr",value=>{
  let reSpc = /^[^!！@#\$%\^&\*]+$/;
  if(reSpc.test(value)){
    return true
  }
  return "不允许输入!@#$%^&*等特殊字符";
})
//账号不支持中文 只能以字母开头 字母或者是数字组合
extend("eLetterNum", value => {
  let reg = /^[a-zA-Z][a-zA-Z0-9]*$/
  if (reg.test(value)) {
    return true;
  }
  return "请输入正确的{_field_}(由字母开头，数字组合)";
});

//由中文字符、英文字母、数字、中划线、下划线/.
extend("mixedInput", value => {
  let re = /^[\u4e00-\u9fa5_a-zA-Z0-9-_.]+$/;
  if (re.test(value)) {
    return true;
  }
  return "请输入正确的{_field_}(由中文字符、英文字母、数字、中划线、下划线和点组成)";
});

//不能以 =+-@开头
extend("start", value => {
  let re = /^[\+|\-|\=|\@].*$/;
  if (!re.test(value)) {
    return true;
  }
  return "{_field_}格式不正确，请重新输入";
});
//8-32位带大小写，数字，特殊字符任意两种
extend("checkPassword", value => {
  let re = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{8,32}$/;
  if (re.test(value)) {
    return true
  }
  if(value.length<8 || value.length>32){
    return "密码为8-32个字符";
  }else{
    return "密码至少包含大小写字母、数字和特殊字符中的两种";
  }
})
//中文
extend("notChinese", value => {
  let re = /^[^\u4e00-\u9fa5]+$/;
  if (re.test(value)) {
    return true;
  }
  return "不允许输入中文，请重新输入";
});
//15-20位只有数字，字母组成  纳税人识别号
extend("checkIdentify", value => {
  let re = /^[0-9a-zA-Z]{15,20}$/;
  if (re.test(value)) {
    return true
  }
  return "请输入只能包含数字或字母的15-20个字符的纳税人识别号";
})

//真实姓名/由中文字符、英文字母
extend("checkName", value => {
  let re = /^[\u4e00-\u9fa5_a-zA-Z ]+$/;
  if (re.test(value)) {
    return true;
  }
  return "请输入正确的{_field_}";
});
//渠道名、联系人
extend("attrName", value => {
  let re = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/im;
  if (re.test(value)) {
    return true;
  }
  return "请输入正确的{_field_}(由中文、数字、字母组成)";
});
//最低8个字符最高32个字符
extend("num8n32", value => {
  if (value && value.length >= 8 && value.length <= 32) {
    return true;
  }
  return "请输入正确的{_field_}(8-32的字符)";
});
//最低2个字符最高8个字符
extend("num2n8", value => {
  if (value && value.length >= 2 && value.length <= 8) {
    return true;
  }
  return "请输入正确的{_field_}(2-8的字符)";
})
//最低6个字符最高50个字符
extend("num6n50", value => {
  if (value && value.length >= 6 && value.length <= 50) {
    return true;
  }
  return "请输入正确的{_field_}(6-50的字符)";
});
//最低2个字符最高10个字符
extend("num2n10", value => {
  if (value && value.length >= 2 && value.length <= 10) {
    return true;
  }
  return "请输入正确的{_field_}(2-10的字符)";
})
//最低1个字符最高25个字符
extend("num1n25", value => {
  if (value && value.length >= 1 && value.length <= 25) {
    return true;
  }
  return "请输入正确的{_field_}(1-25的字符)";
})
//最低15个字符最高20个字符
extend("num15n20", value => {
  if (value && value.length >= 15 && value.length <= 20) {
    return true;
  }
  return "请输入正确的{_field_}(15-20的字符)";
})
//身份证号码/15或18位，15位时全为数字，18位前17位为数字，最后一位可能为数字或字符X或x
extend("checkCard", value => {
  let re = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|[a-z]|[A-Z])$)/;
  if (re.test(value)) {
    return true;
  }
  return "请输入正确的{_field_}";
});
//企业名称 不能纯数字
extend("notNum", value => {
  let re = /^[0-9]+$/;
  if (!re.test(value)) {
    return true;
  }
  return "{_field_}格式不正确，请重新输入";
});

extend("inputError", value => {
  return "账号不存在！";
});

extend("registerPhone", value => {
  return "该手机号已有3个账号，注册数量超限";
});

//企业名称 不能纯特殊字符
extend("notSpec", value => {
  let re1 = /^[A-Za-z]+$/;
  let re2 = /^[0-9]+$/;
  let re3 = /^[\u4e00-\u9fa5]+$/;
  let reSpc = /^[~！!@#$￥¥%\…\…&*()（）^_\-+=《》|——\\<>?？/\[\]{};：,，.。·]+$/;
  if (reSpc.test(value)) {
    if (re1.test(value) && reSpc.test(value)) {
      return true;
    } else if (re2.test(value) && reSpc.test(value)) {
      return true;
    } else if (re3.test(value) && reSpc.test(value)) {
      return true;
    } else if (re1.test(value) && re2.test(value) && reSpc.test(value)) {
      return true;
    } else if (re1.test(value) && re3.test(value) && reSpc.test(value)) {
      return true;
    } else if (re2.test(value) && re3.test(value) && reSpc.test(value)) {
      return true;
    } else if (re1.test(value) && re2.test(value) && re3.test(value) && reSpc.test(value)) {
      return true;
    } else {
      return "{_field_}格式不正确，请重新输入";
    }
  } else {
    return true;
  }

});
// 联系电话  同时校验手机号和座机号
extend("telephone", value => {
  // let re = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/im;
  let re = /^[\(\)\s0-9-\+]{4,20}$/;
  if (re.test(value)) {
    return true;
  }
  return "请输入正确的联系电话";
  // return "请输入正确的{_field_}(手机或座机，如 130******** 或 010-********)";
});
extend("serveTelephone", value => {
  // let re = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/im;
  let re = /^[^\"]{4,50}$/;
  if (re.test(value)) {
    return true;
  }
  return "请输入4到50位的联系电话";
  // return "请输入正确的{_field_}(手机或座机，如 130******** 或 010-********)";
});
//jinna
extend("phone", value => {
  let re = /^((0\d{2,3}-\d{7,9})|(1[3657849]\d{9}))$/;
  if (re.test(value)) {
    return true;
  }
  return "请输入正确的联系电话";
  // return "请输入正确的{_field_}(手机或座机，如 130******** 或 010-********)";
});
// 微信校验 微信账号仅支持6-20个字母、数字、下划线或减号，以字母开头
extend("wechat", value => {
  let re = /^[a-zA-Z]{1}[-_a-zA-Z0-9]{5,19}$/;
  if (re.test(value)) {
    return true;
  }
  return "请输入正确的微信号";
});
// 校验是否包含输入法表情
extend("emoji", value => {
  let flag = emoji().exec(value);
  if (!flag) {
    return true;
  }
  return "请勿在{_field_}输入表情"
})
// 金额 有效位数传参，默认2位
extend("money", {
  validate(value, args = 2) {
    let re = new RegExp(`^(0|([1-9][0-9]*)|([0]\.[0-9]{1,2})|([1-9][0-9]*\.[0-9]{1,${args}}))$`);
    if (args === 0) {
      re = new RegExp(`^[1-9][0-9]*$`);
    }
    if (re.test(value)) {
      return true;
    } else {
      return "{_field_}格式不正确(小数点后仅支持两位有效位数)";
    }
  }
});
// 金额 保留两位数 不能为0
extend("amount", {
  validate(value) {
    let re = new RegExp(`^(0|([1-9][0-9]*)|([0]\.[0-9]{1,2})|([1-9][0-9]*\.[0-9]{1,2}))$`);
    if (re.test(value)) {
      if (Number(value) < 0.01) {
        return "金额不能小于0.01";
      } else {
        return true;
      }
    } else {
      return "{_field_}格式不正确(小数点后仅支持两位有效位数)";
    }
  }
});
// 金额，下拨金额，暂时兼容用
extend("allocatemoney", {
  validate(value, args = [2, 0, 99999999.99]) {
    // args[0] 保留位数
    // args[1] 最小值
    // args[2] 最大值
    let digit = args[0] || 2;
    let minNum = args[1] || 0;
    let maxNum = args[2] || 99999999.99;
    if (isNaN(Number(value))) {
      return `请输入${minNum}~${maxNum}的数字`;
    }
    let re = new RegExp(`^(0|([1-9][0-9]*)|([0]\.[0-9]{1,2})|([1-9][0-9]*\.[0-9]{1,${digit}}))$`);
    if (digit == '0') {
      re = new RegExp(`^[1-9][0-9]*$`);
    }
    if (re.test(value)) {
      if (parseFloat(value) < minNum || parseFloat(value) > maxNum) {
        return `请输入${minNum}~${maxNum}的数字`;
      } else {
        return true;
      }
    } else {
      let valStr = value + '';
      if (valStr.indexOf('.') !== -1 && valStr.slice(valStr.indexOf('.') + 1).length > digit) {
        return `仅支持输入小数点后两位有效数字`;
      }
      return `请输入${minNum}~${maxNum}的数字`;
    }
  }
});
// 金额-充值自用
extend("rechargeMoney", {
  validate(value, args = [2, 0, 99999999.99]) {
    // args[0] 保留位数
    // args[1] 最小值
    // args[2] 最大值
    let digit = args[0] || 2;
    let minNum = args[1] || 0;
    let maxNum = args[2] || 99999999.99;
    if (isNaN(Number(value))) {
      return `请输入${minNum}~${maxNum}的数字`;
    }
    let re = new RegExp(`^(0|([1-9][0-9]*)|([0]\.[0-9]{1,2})|([1-9][0-9]*\.[0-9]{1,${digit}}))$`);
    if (digit == '0') {
      re = new RegExp(`^[1-9][0-9]*$`);
    }
    if (re.test(value)) {
      if (parseFloat(value) > maxNum) {
        return `单笔充值最大限额${maxNum}，超出请多次充值`;
      } else if (parseFloat(value) < minNum) {
        return `请输入${minNum}~${maxNum}的数字`;
      } else {
        return true;
      }
    } else {
      let valStr = value + '';
      if (valStr.indexOf('.') !== -1 && valStr.slice(valStr.indexOf('.') + 1).length > digit) {
        return `仅支持输入小数点后两位有效数字`;
      }
      return `请输入${minNum}~${maxNum}的数字`;
    }
  }
});
// 最大数字
extend("maxNum", {
  validate(value = 0, args = 0) {
    if (!value || isNaN(value)) {
      return "{_field_}格式不正确，请重新输入";
    }
    if (parseFloat(value) > parseFloat(args)) {
      return `{_field_}最多为${args}个字符`;
    }
    return true;
  },
});
// 最小数字
extend("minNum", {
  validate(value = 0, args = 0) {
    if (!value || isNaN(value)) {
      return "{_field_}格式不正确，请重新输入";
    }
    if (parseFloat(value) < parseFloat(args)) {
      return `{_field_}不能低于${args}`;
    }
    return true;
  },
});
//下拨金额判断
extend("grantAmount", {
  validate(value, args) {
    if (Number(args.value) <= 0) {
      return "当前无可下拨金额"
    }
    return true;
  },
  params: ["value"],
});
//代金券面值判断
extend("voucherAmount", {
  validate(value, args) {
    if (Number(args.value) <= 0) {
      return "当前无代金券面值"
    }
    return true;
  },
  params: ["value"],
});

//中文字符
extend("chineseCharacter", value => { 
  //匹配这些中文标点符号 。 ？ ！ ， 、 ； ： “ ” ‘ ' （ ） 《 》 〈 〉 【 】 『 』 「 」 ﹃ ﹄ 〔 〕 … — ～ ﹏ ￥
  var reg = /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/;
  if (!reg.test(value)) {
    return true;
  } else {
    return "{_field_}不能包含中文标点符号";
  }
});

//数字和大写字母
extend("numbersCaps", value => {
    let re = /^[A-Z0-9]+$/;
    if (re.test(value)) {
      return true;
    }
    return "只允许输入数字或者数字和大写字母，请重新输入";
  });

extend("attrtNum", value => {
  let re = /[^\u4e00-\u9fa5]{1,100}$/;
  if (re.test(value)) {
      return true;
  }
  return "请输入正确的{_field_}(100以内，数字、字母、特殊字符组成)";
});
extend("specialStr",value=>{
  let reSpc = /^[^!！@#\$%\^&\*]+$/;
  if(reSpc.test(value)){
    return true
  }
  return "不允许输入!@#$%^&*等特殊字符";
})

Vue.component("ValidationProvider", ValidationProvider);



// WEBPACK FOOTER //
// ./src/common/validator-rule.js